<template>

</template>

<script>
    export default {
        name: 'competitorsTable',
        data() {
            return {
                showTable: false,
            }
        }
    }
</script>